import { AppInfo } from "shared-ts-app-info";

export const appKey = "ff-mcu";
export const appName = "My Chimney Users";
export const appRelease = "Continuously";

export const appInfo: AppInfo = {
  key: appKey,
  name: appName,
  release: appRelease,
};
